<template>
  <div>
    <div >
      
      <span style="float: right;">
        <el-button v-if="checkStatus == 1" type="text" style="float: right;" >
        <el-tooltip class="item" effect="dark" :content="checkResult | result" placement="top">
          <span>原因</span>
        </el-tooltip>
      </el-button>
        <el-switch
            v-if="checkStatus ==1 || checkStatus ==2 "
            :width="50"
            class="mr10 fl mt10"
            v-model="checkStatus"
            active-color="#13ce66"
            inactive-color="#ff4949"
            :active-value=2
            :inactive-value=1
            @change="checkPass(checkStatus)"
        >
      </el-switch>
      <el-switch
          v-if="checkStatus ==3 || checkStatus ==4 "
          :width="50"
          class="mr10 fl mt10"
          v-model="checkStatus"
          active-color="#13ce66"
          inactive-color="#ff4949"
          :active-value=4
          :inactive-value=3
          @change="checkPass(checkStatus)"
      >
      </el-switch>
      <el-switch
          v-if="checkStatus ==0"
          :width="50"
          class="mr10 fl mt10"
          v-model="checkStatus"
          active-color="#13ce66"
          inactive-color="#ff4949"
          :active-value=2
          :inactive-value=0
          @change="checkPass(checkStatus)"
      >
      </el-switch>
      </span>
      
    </div> <br><br>
    <div v-html="htmlContent" class="rich">
      <div></div>
    </div>
  </div>
</template>

<script>
  import https from '@/https.js';
  
  export default {
    name: 'TextPage',
    props: ['courseId','catalogId','resourceType','resourceId'],
    data() {
      return {
        htmlContent: '',
        checkStatus: '',
        checkResult: '',
      };
    },
    methods: {
      getResource() {
        let params = {
          "catalogId":this.catalogId
        }
        https.fetchPost('/resources/get', params, 'json').then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if (code == '200') {
            this.htmlContent = data.data.data.content;
            this.checkStatus = data.data.data.checkStatus;
            this.checkResult = data.data.data.checkResult;
          } else {
            this.$message({
              type: 'info',
              message: '加载失败:' + msg
            });
          }
        }).catch(err => {
              console.log(err);
            }
        );
      },
      checkPass(checkStatus) {

        if(checkStatus == 1) {
          this.checkStatus = 3;
        }

        if(checkStatus == 2) {
          this.checkStatus = 4;
        }

        let params = { // 0 目录 1资源
          courseId: this.courseId,
          resourceId: this.resourceId,
          resourceType: 1,
          checkStatus: this.checkStatus
        };
        https.fetchPost('/courseCheck/checkPass',params ,"json").then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if(code == '200') {
            this.$message({
              type: 'success',
              message: '操作成功'
            });
          } else {
            this.$message({
              type: 'info',
              message: '加载失败'+msg
            });
          }
        }).catch(err=>{
              console.log(err)
            }
        )
      },
    },
    filters: {
      result(val) {
        return "文本内容"+val;
      }
    },
    created: function() {
      console.log(this.courseId);
      this.getResource();
    }
  };
</script>

<style scoped>

</style>
